<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="用户名称:">
                    <el-input class="s-input" v-model="queryParams.username" placeholder="请输入用户名称：" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="身份证号:">
                    <el-input class="s-input" v-model="queryParams.number" placeholder="请输入身份证号码：" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="状态:">
                    <el-select v-model="queryParams.state" placeholder="请选择状态" clearable @change="changeQuery">
                        <el-option label="待审" :value="1"></el-option>
                        <el-option label="审核通过" :value="2"></el-option>
                        <el-option label="驳回" :value="3"></el-option>
                    </el-select>
                </el-form-item>

                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
            </el-form>
            <div class="action">
                <el-button type="primary" @click="add()">新增</el-button>
            </div>
            <!-- 表格内容 -->
            <el-table v-loading="loading" element-loading-text="数据加载中" stripe border :data="pageInfo.list">
                <el-table-column label="id" prop="id" width="80" align="center"></el-table-column>
                <el-table-column label="用户id" prop="uid" width="80" align="center"></el-table-column>
                <el-table-column label="客户名称" prop="username" width="200" align="center"></el-table-column>
                <el-table-column label="身份证正面" align="center" width="100" prop="positive">
                    <template slot-scope="scope">
                        <el-image @click="showBigImg(scope.$index,'img1')" style="height:23px;width:30px;" fit="cover" :class="`img1column${scope.$index}`" :src="scope.row.positive" :preview-src-list="[scope.row.positive]">
                            <div slot="error" class="image-slot">
                                <el-image :src="defaultImg" class="center_image"></el-image>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label="身份证反面" align="center" width="100" prop="back">
                    <template slot-scope="scope">
                        <el-image @click="showBigImg(scope.$index,'img2')" style="height:23px;width:30px;" fit="cover" :class="`img2column${scope.$index}`" :src="scope.row.back" :preview-src-list="[scope.row.back]">
                            <div slot="error" class="image-slot">
                                <el-image :src="defaultImg" class="center_image"></el-image>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label="身份证号码" prop="number" width="200" align="center"></el-table-column>
                <el-table-column label="理由" prop="reason" width="200" align="center"></el-table-column>
                <el-table-column label="协议地址" prop="agreement" width="200" align="center"></el-table-column>
                <el-table-column label="状态" prop="state" width="180" align="center">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.state === 1">待审</el-tag>
                        <el-tag type="primary" v-if="scope.row.state === 2">审核通过</el-tag>
                        <el-tag type="primary" v-if="scope.row.state === 3">驳回</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" fixed="right" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑</el-button>
                        <el-button v-if="scope.row.state === 1" type="text" class="green" @click="sync(scope.row.id)">
                            同步审核</el-button>
                        <el-button v-if="scope.row.state === 1" type="text" class="red" @click="states(scope.row.id)">驳回
                        </el-button>

                        <el-button v-if="scope.row.state === 1" type="text" class="green" @click="state(scope.row, 2)">
                            通过</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <!-- 编辑添加邀请码 -->
        <el-dialog :title="title" :visible.sync="addVisible" width="600px" class="dialog_box" v-if="addVisible">
            <el-form class="form-box" ref="form" v-bind:rules="rules" v-bind:model="form" v-loading.body="loading" label-position="left" label-suffix=":" label-width="100px" size="large" element-loading-text="上传中">
                <el-form-item label="名称" prop="username">
                    <el-input v-model="form.username" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="uid" prop="uid">
                    <el-input v-model="form.uid" placeholder="请输入uid" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="number">
                    <el-input v-model="form.number" placeholder="请输入身份证号码"></el-input>
                </el-form-item>
                <el-form-item label="身份证正面" prop="positive">
                    <el-input v-model="form.positive" placeholder="请输入身份证正面"></el-input>
                    <el-button @click.prevent="choiceImg('positive')">选择图片</el-button>
                    <el-upload class="avatar-uploader up img1" :action="IMAGE_UPLOAD_PRO_URL" :show-file-list="false" :on-success="handlePositiveSuccess" :before-upload="beforePositiveUpload" name="file" :headers="header">
                        <img v-if="form.positive " :src="form.positive " class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <span class="span_gray">建议尺寸243*153像素</span>
                </el-form-item>
                <el-form-item label="身份证反面" prop="back">
                    <el-input v-model="form.back" placeholder="请输入身份证正面"></el-input>
                    <el-button @click.prevent="choiceImg('back')">选择图片</el-button>
                    <el-upload class="avatar-uploader up img2" :action="IMAGE_UPLOAD_PRO_URL" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" name="file" :headers="header">
                        <img v-if="form.back" :src="form.back" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <span class="span_gray">建议尺寸243*153像素</span>
                </el-form-item>
                <el-form-item label="协议地址" prop="agreement">
                    <el-input v-model="form.agreement"></el-input>
                </el-form-item>
                <el-form-item label="理由" prop="reason">
                    <el-input v-model="form.reason"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <el-radio-group v-model="form.state">
                        <el-radio :label="2">审核通过</el-radio>
                        <el-radio :label="1">待审</el-radio>
                        <el-radio :label="3">驳回</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveData">提 交</el-button>
            </div>
        </el-dialog>

        <!-- 上线、下线提示框 -->
        <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
            <div class="del-dialog-cnt">{{ confirmContent }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="stateData">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 驳回提示框 -->
        <el-dialog title="提示" :visible.sync="confirmVisibles" width="600px" center>
            <!-- <div class="del-dialog-cnt">{{ confirmContents }}</div> -->
            <el-form class="dialog_box" ref="forms" v-bind:rules="rules" v-bind:model="forms" v-loading.body="loading" label-position="left" label-suffix=":" :rule="rules" label-width="100px" element-loading-text="上传中">
                <el-form-item label="驳回理由" prop="reason">
                    <el-input v-model="forms.reason" placeholder="驳回理由" type="textarea" :rows="2"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisibles = false">取 消</el-button>
                <el-button type="primary" @click="stateDatas">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 选择图片对话框 -->
        <div class="img">
            <Picture :ImgVisible="ImgVisible" @toggleImg="toggleImg" @getImg="getImg"></Picture>
        </div>
    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb'
import Pagination from '@/components/Pagination'
import { request } from '@/common/request'
import { deal } from '@/common/main'
import loadEvents from '@/utils/loading'
let loads = new loadEvents();
import Picture from '@/components/Picture';
import {IMAGE_UPLOAD_PRO_URL} from "../../common/const";
export default {
    name: 'StoreInfo',
    components: {
        Breadcrumb,
        Pagination,
        Picture
    },
    data() {
        return {
            IMAGE_UPLOAD_PRO_URL:IMAGE_UPLOAD_PRO_URL,
            ImgVisible: false,
            text: 'image',
            disabled: false,
            defaultImg: require('../../assets/img/zhan.jpeg'),
            header: {},
            menuList: ['客户', '客户认证'],
            loading: false,
            confirmVisible: false,
            confirmVisibles: false,
            confirmContent: '',
            confirmContents: '',
            queryParams: {
                page: 1,
                pagesize: 10,
            },
            pageInfo: {},
            brandList: [],
            addVisible: false,
            addVisibles: false,
            title: '添加客户认证',
            rules: {
                username: [{
                    required: true,
                    message: '名称不能为空',
                    trigger: 'blur'
                }],
                uid: [{
                    required: true,
                    message: 'uid不能为空',
                    trigger: 'blur'
                },
                {
                    pattern: '^[0-9]*$',
                    message: "请输入数字"
                }],
                number: [
                    { validator: deal.checkSfzhmcode, trigger: ['blur', 'change'], required: true, }
                ],
                positive: [{
                    required: true,
                    message: '身份证正面不能为空',
                    trigger: ['blur', 'change']
                }],
                back: [{
                    required: true,
                    message: '身份证反面不能为空',
                    trigger: ['blur', 'change']
                }],
                state: [{
                    required: true,
                    message: '状态不能为空',
                    trigger: 'blur'
                }],
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            forms: {},
            mode: 'add',
            form: {
            },
        }
    },
    created() {
        this.header.token = localStorage.getItem('token');
        this.header.platform = 'admin';
        this.loadData()
    },

    methods: {
        toggleImg(val) { // 关闭 img对话框
            this.ImgVisible = val;
        },
        choiceImg(text) {
            this.text = text
            this.ImgVisible = true
        },
        getImg(url) {// 获取选择的img
            this.$set(this.form, this.text, url);
        },
        // 查看大图
        showBigImg(index, node) {
            this.$nextTick(function () {
                let shows = document.getElementsByClassName(`${node}column${index}`)
                let show = shows[0].getElementsByClassName('el-image-viewer__wrapper')
                show[0].style['display'] = 'block'
                let dom = show[0].getElementsByClassName('el-image-viewer__mask')
                dom[0].addEventListener('click', function () {
                    show[0].style['display'] = 'none'
                })
            })
        },
        //图片上传
        handleAvatarSuccess(res, file) {
            if (res.code == 1) {
                loads.close()
                this.$set(this.form, 'back', res.data.uri);
            }
        },
        beforeAvatarUpload(file) {
            loads.open(`.img2 .el-upload`, '上传中')
            const _this = this
            return deal.imageFormat(file, _this, 300)
        },
        handlePositiveSuccess(res, file) {
            if (res.code == 1) {
                loads.close()
                this.$set(this.form, 'positive', res.data.uri);
            }
        },
        beforePositiveUpload(file) {
            loads.open(`.img1 .el-upload`, '上传中')
            const _this = this
            return deal.imageFormat(file, _this, 300)
        },
        //状态
        state(row, state) {
            if (state == 3) {
                this.confirmContent = '确定是否驳回?';

            }
            else {
                this.confirmContent = '确定是否通过?';
            }
            this.form = Object.assign({}, row);
            this.form.state = state;
            this.form.ctime = deal.timestamp(this.form.ctime);
            this.form.etime = deal.timestamp(this.form.etime);
            this.confirmVisible = true;
        },
        //状态
        states(id) {
            this.confirmVisibles = true;
            this.forms.state = 3
            this.forms.id = id
        },

        loadData() {
            this.loading = true;
            //用户认证列表
            request.get('/account/auth/list', this.queryParams).then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function (val) {
                    })
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //分页
        changeQuery() {
            this.queryParams.page = 1
            this.loadData()
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val
            this.loadData()
        },
        refreshPageNum(val) {
            this.queryParams.page = val
            this.loadData()
        },
        add(id, index) {
            this.disabled = false
            this.mode = 'add';
            this.form = { num: 1, countType: 1, ty: 1 }
            this.addVisible = true
            this.form = {
                state: 1,
            };
            if (this.$refs.form) {
                this.$refs.form.clearValidate()
            }
        },
        //编辑
        edit(index, row) {
            this.disabled = true
            this.mode = 'edit';
            this.title = '编辑';
            const item = this.pageInfo.list[index];
            let time = [item.stime, item.etime]
            //处理时间
            this.form = Object.assign({}, item);
            this.form.uid = this.form.uid + ''
            this.$set(this.form, 'time', time);
            this.addVisible = true;
            if (this.$refs.form) {
                this.$refs.form.clearValidate()
            }
        },
        delete(id, index) {

        },
        changeCount(num) {
            this.form.num = num
        },
        changeDatePicker: function () {
            let vue = this
            if (vue.pickerDatad != null) {
                vue.form.stime = vue.pickerDatad[0]
                vue.form.etime = vue.pickerDatad[1]
            } else {
                vue.form.stime = null
                vue.form.etime = null
            }
        },
        //增加编辑
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        //   this.form.num = this.form.countType == 1 ? 1 : this.form.num;
                        // this.form.brand_ids = this.form.brand_id;
                        var url = this.mode == 'add' ? '/account/auth/add' : '/account/auth/edit';
                        request.post(url, this.form).then(ret => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.addVisibles = false;
                                this.loadData();
                                this.$message.success((this.mode == 'add' ? '新增' : '编辑') +
                                    '成功');
                                this.$refs.form.clearValidate()
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$message.error('请补全信息');
                        return false;
                    }
                });
            };
        },
        // 确定下线
        stateData() {
            request.post('/account/auth/edit', this.form).then(ret => {
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 驳回
        stateDatas() {
            request.post('/account/auth/edit', this.forms).then(ret => {
                console.log(6666, this.forms)
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisibles = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 同步审核
        sync(id) {
            this.loading = true
            request.post('/account/auth/syn', { id: id }).then(ret => {
                if (ret.code == 1) {
                    this.isSync = true
                    this.loading = false
                    this.$message.success('同步成功')
                    this.loadData();
                } else {
                    this.$message.error(ret.msg);
                    this.loadData();
                }

            });
        }
    }
}

</script>

<style scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}

/* 对话框样式 */

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}

/* 图片样式 */
.dialog_box .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}

.dialog_box .avatar {
    font-size: 28px;
    width: 200px;
    height: 100px;
    line-height: 100px;
}

.dialog_box .span_gray {
    font-size: 12px;
    color: gray;
}

.dialog_box .up {
    margin-top: 10px;
    margin-bottom: -10px;
}
.dialog_box .el-button {
    margin-left: 20px;
}
.dialog_box >>> .el-textarea {
    width: 80%;
}
</style>
